export enum SeatConfigurationType {
  GENERAL_ADMISSION = 'GENERAL_ADMISSION',
  SEATED = 'SEATED',
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/model/seat-configuration-type.ts